import { render, staticRenderFns } from "./TransferDetailComponent.vue?vue&type=template&id=17b93162&"
import script from "./TransferDetailComponent.vue?vue&type=script&lang=js&"
export * from "./TransferDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports